import { useEffect, useRef, useMemo } from "react";
import { useThree } from "@react-three/fiber";
import * as THREE from "three";

import gsap from "gsap";

const SceneThree = ({ level, setWorldPosition, changeBackground }) => {
  const ref = useRef();

  const loader = new THREE.TextureLoader();
  const { scene } = useThree();

  const width = window.innerWidth;
  const height = window.innerHeight;
  const aspect = width / height;

  // const leftOval = useMemo(() => loader.load("Egg shap.webp"), [])
  const leftOval = useMemo(
    () =>
      loader.load("Egg shap.webp", function (data) {
        leftOval.colorSpace = THREE.SRGBColorSpace;
        leftOval.minFilter = THREE.LinearFilter;
        var tex = leftOval.clone();

        tex.needsUpdate = true;
      }),
    []
  );

  // const leftOval = loader.load("Egg shap.png");

  // const rightSquare = useMemo(() => loader.load("Ractangle.webp"), [])
  // // const rightSquare = loader.load("Ractangle.png");
  // leftOval.colorSpace = THREE.SRGBColorSpace;
  // leftOval.minFilter = THREE.LinearFilter;
  // rightSquare.colorSpace = THREE.SRGBColorSpace;
  // rightSquare.minFilter = THREE.LinearFilter;

  const rightSquare = useMemo(
    () =>
      loader.load("Ractangle.webp", function (data) {
        rightSquare.colorSpace = THREE.SRGBColorSpace;
        rightSquare.minFilter = THREE.LinearFilter;
        var tex = rightSquare.clone();

        tex.needsUpdate = true;
      }),
    []
  );

  useEffect(() => {
    return () => {
      scene.traverse(function (child) {
        if (child instanceof THREE.Mesh) {
          child.geometry.dispose();
          child.material.dispose();
        }
      });
    };
  }, []);

  useEffect(() => {
    // setWorldPosition(null)

    if (changeBackground === "ovals") {
      if (ref.current && (level === 3 || level === 4 || level === 5)) {
        LeftRighMiddle();
      }
    } else if (changeBackground === "square") {
      if (ref.current && (level === 3 || level === 4 || level === 5)) {
        LeftRighBack();
      }
    } else if (changeBackground === "hide-2-oval") {
      ref.current.children[0].visible = false;
      ref.current.children[2].visible = false;
    } else if (changeBackground === "") {
      setWorldPosition(null);
    }
  }, [changeBackground, level]);

  function LeftRighMiddle() {
    var vector = new THREE.Vector2();

    ref.current.children[3].visible = false;
    ref.current.children[1].visible = true;
    ref.current.children[2].visible = true;
    ref.current.children[0].visible = true;

    vector.x = ((vector.x / 2) * window.innerWidth) / window.innerHeight;
    vector.y = ((-vector.y / 2) * window.innerHeight) / window.innerHeight;

    gsap.to(ref.current.children[0].position, {
      x: vector.x - aspect - aspect,
      y: vector.y,
      duration: 0.5,
      onComplete: () => {
        const position = new THREE.Vector3();

        ref.current.children[0]?.getWorldPosition(position);
        const xPosition = ref.current.children[0].scale.x - position.x;

        setWorldPosition((prev) => ({ ...prev, left: position }));
      },
    });

    gsap.to(ref.current.children[1].position, {
      x: vector.x,
      y: vector.y + aspectWidth / 1.5,
      duration: 0.5,
      onComplete: () => {
        const position = new THREE.Vector3();
        ref.current.children[1].getWorldPosition(position);

        setWorldPosition((prev) => ({ ...prev, middle: position }));
      },
    });
    gsap.to(ref.current.children[2].position, {
      x: vector.x + aspect + aspect,
      y: vector.y,
      onComplete: () => {
        const position = new THREE.Vector3();
        ref.current.children[2].getWorldPosition(position);

        const xPosition = ref.current.children[1].scale.x / 1.5;

        setWorldPosition((prev) => ({
          ...prev,
          right: position,
        }));
      },
    });

    return vector;
  }

  function LeftRighBack() {
    var vector = new THREE.Vector2();
    ref.current.children[1].visible = false;
    ref.current.children[2].visible = false;
    ref.current.children[3].visible = true;
    vector.x = ((vector.x / 2) * window.innerWidth) / window.innerHeight;
    vector.y = ((-vector.y / 2) * window.innerHeight) / window.innerHeight;

    gsap.to(ref.current.children[0].position, {
      x: vector.x - aspect * 2,
      y: vector.y,
      onComplete: () => {
        const position = new THREE.Vector3();
        ref.current.children[0].getWorldPosition(position);
        const xPosition = ref.current.children[0].scale.x - position.x;

        setWorldPosition((prev) => ({
          ...prev,
          left: position,
          middle: new THREE.Vector3(0, 0, 0),
        }));
      },
    });
    gsap.to(ref.current.children[3].position, {
      x: vector.x + aspect * 2,
      y: vector.y,
      onComplete: () => {
        const position = new THREE.Vector3();
        ref.current.children[3].getWorldPosition(position);

        const xPosition = ref.current.children[3].scale.x - position.x;

        setWorldPosition((prev) => ({
          ...prev,
          right: position,
        }));
      },
    });

    return vector;
  }

  const { viewport: v, aspect: aspectt } = useThree();

  function useAspect(width, height, factor = 0.12) {
    const adaptedHeight =
      height * (aspectt > width / height ? v.width / width : v.height / height);
    const adaptedWidth =
      width * (aspectt > width / height ? v.width / width : v.height / height);

    return [adaptedWidth * factor, adaptedHeight * factor, 1];
  }

  const [aspectWidth, aspectHeight] = useAspect(
    window.innerWidth,
    window.innerHeight
  );

  return (
    <group ref={ref}>
      <mesh scale={[aspectWidth * 2, aspectWidth * 2, 1]}>
        <sprite>
          <spriteMaterial attach={"material"} map={leftOval} />
        </sprite>
      </mesh>

      <mesh scale={[aspectWidth * 2, aspectWidth * 2, 1]}>
        <sprite>
          <spriteMaterial attach={"material"} map={leftOval} />
        </sprite>
      </mesh>

      <mesh scale={[aspectWidth * 2, aspectWidth * 2, 1]}>
        <sprite>
          <spriteMaterial attach={"material"} map={leftOval} />
        </sprite>
      </mesh>
      <mesh scale={[aspectWidth * 3.5, aspectWidth * 3.5, 1]}>
        <sprite>
          <spriteMaterial attach={"material"} map={rightSquare} />
        </sprite>
      </mesh>
    </group>
  );
};

export default SceneThree;
